const t = {
  regular: { fontWeight: "regular" },
  medium: { fontWeight: "medium" },
  semiBold: { fontWeight: "semibold" },
  light: { fontWeight: "light" }
};
export {
  t as weight
};
